import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

const initializeSwiperClientes = () => {
    document.addEventListener("DOMContentLoaded", function () {
        const swiper = new Swiper(".mySwiperClientes", { 
            slidesPerView: "auto",
            spaceBetween: 24,
             speed: 5000,
						autoplay:{
							delay: 1 ,
						},
            loop: true,
            watchOverflow: true, // Ajustado para evitar espaço extra
         allowTouchMove: false,
  simulateTouch: false,

  // impede cliques em links dentro dos slides
  preventClicks: true,
  preventClicksPropagation: true,

  // se você usa classe noSwiping para áreas específicas:
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
        });

				const swiper2 = new Swiper(".swiper-clientes", { 
            slidesPerView: "auto",
            spaceBetween: 24,
            speed: 5000,
						autoplay:{
							delay: 1 ,
						},
            loop: true,
            watchOverflow: true, // Ajustado para evitar espaço extra
       allowTouchMove: false,
  simulateTouch: false,

  // impede cliques em links dentro dos slides
  preventClicks: true,
  preventClicksPropagation: true,

  // se você usa classe noSwiping para áreas específicas:
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
        });
    });
};

export default initializeSwiperClientes;
